import { render } from "./나의건강관리_메인.vue?vue&type=template&id=4de3d72f"
import script from "./나의건강관리_메인.vue?vue&type=script&lang=js"
export * from "./나의건강관리_메인.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__